import React, { useState } from "react";
import { Card } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Axios from "axios";
import CryptoJS from "crypto-js";

import { useEffect } from "react";
import DocumentsNeeded from "./DocumentsNeeded";
import PdfDocuments from "./PdfDocuments";
import Highlights from "./Highlights";
import { getLocalData } from "../../Utilities/Common/source";
import { CREATE_QUOTE_PAGE_ROUTE } from "../../HealthInsuranceNew/routes";
import axiosInstance from "../../Utilities/djangoAxiosInstance";

const PolicyHighlightPage = () => {
  const [quickQuoteDetails, setQuickQuoteDetails] = useState({});
  const [acuviserProductDetail, setAcuviserProductDetail] = useState({});
  const [videoUrl, setVideoUrl] = useState("");

  const localSource = getLocalData("source");
  console.log("PHP localSource: ", localSource);

  const { productId } = useParams();

  const productIdArray = productId.split("*");
  const productRef = productIdArray[0];
  const responseId = productIdArray[1];
  const Acuvisor_product_id = productIdArray[2];

  const navigate = useNavigate();

  const productRefURI = decodeURIComponent(productRef).toString();
  const responseIdURI = decodeURIComponent(responseId).toString();
  const Acuvisor_product_idURI =
    decodeURIComponent(Acuvisor_product_id).toString();

  const bytesProductRefURI = CryptoJS.AES.decrypt(
    productRefURI,
    "secret key @123"
  );
  const bytesResponseIdURI = CryptoJS.AES.decrypt(
    responseIdURI,
    "secret key @124"
  );
  const bytesAcuvisor_product_idURI = CryptoJS.AES.decrypt(
    Acuvisor_product_idURI,
    "secret key @124"
  );

  const decryptedProductRef = JSON.parse(
    bytesProductRefURI.toString(CryptoJS.enc.Utf8)
  );
  const decryptedResponseId = JSON.parse(
    bytesResponseIdURI.toString(CryptoJS.enc.Utf8)
  );
  const decryptedAcuvisor_product_id = JSON.parse(
    bytesAcuvisor_product_idURI.toString(CryptoJS.enc.Utf8)
  );

  console.log(
    "decryptedResponseId",
    decryptedResponseId,
    decryptedAcuvisor_product_id
  );

  const location = useLocation();
  console.log("location: ", location.state);

  useEffect(() => {
    let formdata = new FormData();
    formdata.append("policy_product_id", decryptedAcuvisor_product_id);
    console.log("form Data", decryptedAcuvisor_product_id);

    let domain = "";


    axiosInstance.post(`api/get-policy-detail/`, formdata).then((res) => {
      console.log("php", res);
      let videoUrlArray;
      if (res.status === 200) {
        setAcuviserProductDetail(res.data[0]);
        //   const videourl = 'https://youtu.be/RbovHUPqnzw';
        //   videoUrlArray = videourl?.split("/");
        //   //console.log('kkk', videoUrlArray[videoUrlArray.length - 1].includes('watch'))
        //   if (videoUrlArray[videoUrlArray.length - 1].includes("watch")) {
        //     let splitWatch = videoUrlArray[videoUrlArray.length - 1].split("=");
        //     setVideoUrl(splitWatch[splitWatch.length - 1]);
        //   } else {
        //     setVideoUrl(videoUrlArray[videoUrlArray.length - 1]);
        //   }
        //   console.log("video url:", videoUrl, "array:", videoUrlArray);
        // };
      }
    });



    location?.state
      ? setQuickQuoteDetails(location?.state)
      : axiosInstance.get(`api/health/transfer-data/${decryptedResponseId}`, {
        params: {
          source: localSource,
        },
      }).then((response) => {
        if (response.status === 200) {
          console.log("response from djamgoo ", response);
          setQuickQuoteDetails(response.data);
        }
      });

    return () => {
      // localStorage.clear();
    };
  }, []);

  const buyPlanHandler = () => {
    let path = "";
    let encryptedProduct_ref = encodeURIComponent(
      CryptoJS.AES.encrypt(
        JSON.stringify(decryptedProductRef),
        "secret key @123"
      ).toString()
    );
    let encryptedDataId = encodeURIComponent(
      CryptoJS.AES.encrypt(
        JSON.stringify(decryptedResponseId),
        "secret key @124"
      ).toString()
    );
    let encryptedAcuvisorProduct_Id = encodeURIComponent(
      CryptoJS.AES.encrypt(
        JSON.stringify(decryptedAcuvisor_product_id),
        "secret key @124"
      ).toString()
    );
    //console.log('gg', encryptedProduct_ref, encryptedAcuvisorProduct_Id, encryptedAcuvisorProduct_Id)
    if (
      quickQuoteDetails.Acuvisor_product_id === 90001 ||
      quickQuoteDetails.Acuvisor_product_id === 90002 ||
      quickQuoteDetails.Acuvisor_product_id === 90003 ||
      quickQuoteDetails.Acuvisor_product_id === 90004
    ) {
      //window.open(`https://dev.acuvisor.com/V2/health-insurance/proposalForm?data=${quickQuoteDetails.A_id}`, "_self")
      let domain = "";
      if (window.location.hostname === "localhost") {
        domain = process.env.REACT_APP_LOCAL_GO_DIGIT_DOMAIN;
      } else if (window.location.hostname.trim() === "acuvisor.com") {
        domain = process.env.REACT_APP_PRODUCTION_GO_DIGIT_DOMAIN;
      } else {
        domain = process.env.REACT_APP_LOCAL_GO_DIGIT_DOMAIN;
      }
      Axios.get(
        `${domain}/V2/acuHealthInsurance/setSpotID/${quickQuoteDetails.A_id}`
      ).then((res) => {
        console.log("AIDENCRY", res.data);
        if (res.status === 200) {
          window.open(
            `${domain}/V2/health-insurance/proposalForm?data=${res.data}`,
            "_self"
          );
        }
      });
      //window.open(`https://dev.acuvisor.com/V2/health-insurance/proposalForm?data=${}`, "_self")
    } else if (
      quickQuoteDetails.Acuvisor_product_id === 33333 ||
      quickQuoteDetails.Acuvisor_product_id === 33222 ||
      quickQuoteDetails.Acuvisor_product_id === 33111 ||
      quickQuoteDetails.Acuvisor_product_id === 70015 ||
      quickQuoteDetails.Acuvisor_product_id === 70018 ||
      quickQuoteDetails.Acuvisor_product_id === 70001 ||
      quickQuoteDetails.Acuvisor_product_id === 15032301 ||
      quickQuoteDetails.Acuvisor_product_id === 15032302 ||
      quickQuoteDetails.Acuvisor_product_id === 15032303 ||
      quickQuoteDetails.Acuvisor_product_id === 15032304 ||
      quickQuoteDetails.Acuvisor_product_id === 65032301 ||
      quickQuoteDetails.Acuvisor_product_id === 65032302 ||
      quickQuoteDetails.Acuvisor_product_id === 55032301 ||
      quickQuoteDetails.Acuvisor_product_id === 55032302 ||
      quickQuoteDetails.Acuvisor_product_id === 31072023
    ) {
      path = `/health-insurance/ckyc/${encryptedProduct_ref}*${encryptedDataId}*${encryptedAcuvisorProduct_Id}`;
    } else if (quickQuoteDetails.Acuvisor_product_id === 30102023) {
      path = `${CREATE_QUOTE_PAGE_ROUTE}/${encodeURIComponent(
        encryptedDataId
      )}/${encodeURIComponent(Acuvisor_product_id)}`;
    } else {
      path = `/health-insurance/product/${encryptedProduct_ref}*${encryptedDataId}`;
    }

    navigate(path, localSource);
  };

  // This includes all products destined for the "HealthInsuranceNew" folder.
  const isNewProduct = (acuvisorProductId) => {
    // Add all new product ids here
    const productIds = [31072023];
    return productIds.includes(acuvisorProductId);
  };

  const arrowBackHandler = () => {
    navigate(-1);
  };

  return (
    <>
      {Object.keys(quickQuoteDetails).length > 0 &&
        Object.keys(acuviserProductDetail).length > 0 ? (
        <div className="detailpage">
          <div className="">
            <Card
              style={{
                backgroundColor: "#0c409a",
                color: "white",
                padding: 20,
              }}
            >
              <div className="pro_heading">
                <div className="pro_image">
                  <img
                    className="bg-white img-thumbnail rounded"
                    src={acuviserProductDetail.company_logo}
                  />
                </div>
                <div>
                  <div className="text-capitalize">
                    {acuviserProductDetail.policy_name} -{" "}
                    {quickQuoteDetails.coverType}
                  </div>
                  <div>
                    {acuviserProductDetail.company_name}{" "}
                    {/* - {quickQuoteDetails.coverType} */}
                  </div>
                </div>
              </div>
              <div className="details_container">
                <div>
                  <div>
                    <div>Sum Assured</div>
                    <div>
                      &#8377;{" "}
                      {
                        quickQuoteDetails.sumInsuredValue /* || quickQuoteDetails?.sumInsured */
                      }
                    </div>
                  </div>
                </div>
                <div className="linewithdata">
                  <div className="line"></div>
                  <div>
                    <div>Premium Amount</div>
                    <div>&#8377; {quickQuoteDetails?.totalPremium || quickQuoteDetails?.total_premium }</div>
                  </div>
                </div>
                <div className="linewithdata">
                  <div className="line"></div>
                  <div>
                    <div>Term</div>
                    <div>{quickQuoteDetails.period} Years</div>
                  </div>
                </div>
              </div>
            </Card>
            <div>
              <p style={{ marginLeft: 20, marginTop: 20, fontSize: 20 }}>
                {acuviserProductDetail.company_name}
              </p>
              {/* <iframe
                id="video_url"
                className="w-full h-full"
                src={`https://www.youtube.com/embed/${videoUrl}`}
                allow="autoplay; encrypted-media"
                allowFullScreen
                title="video"
              /> */}
            </div>

            <Card className="id_container">
              <div style={{ marginLeft: 20, marginTop: 20 }}>
                Document Needed
              </div>
              <DocumentsNeeded
                doc1={acuviserProductDetail.document1}
                doc2={acuviserProductDetail.document2}
                doc3={acuviserProductDetail.document3}
                doc4={acuviserProductDetail.document4}
              />
            </Card>

            <div className="pdf_container">
              <PdfDocuments
                doc1={acuviserProductDetail.document_pdf1}
                doc2={acuviserProductDetail.document_pdf2}
                doc3={acuviserProductDetail.document_pdf3}
                doc4={acuviserProductDetail.document_pdf4}
                doc5={acuviserProductDetail.document_pdf5}
                docName1={acuviserProductDetail.document_pdfname1}
                docName2={acuviserProductDetail.document_pdfname2}
                docName3={acuviserProductDetail.document_pdfname3}
                docName4={acuviserProductDetail.document_pdfname4}
                docName5={acuviserProductDetail.document_pdfname5}
              />
            </div>

            <div className="accor_container">
              <p style={{ marginLeft: 20, marginTop: 20 }}>Policy Highlight</p>
              <Highlights highlights={acuviserProductDetail.highlight} />
            </div>
          </div>
          <div className=" btn-sec position-fixed bottom-0 ">
            <button
              className="Goback_btn text-capitalize"
              onClick={() => arrowBackHandler()}
            >
              Go back
            </button>
            <button
              className="submitBtn text-capitalize"
              onClick={() => buyPlanHandler()}
            >
              buy plan
            </button>
          </div>
        </div>
      ) : (
        <h3>Please wait</h3>
      )}
    </>
  );
};

export default PolicyHighlightPage;
